const r = "_wrapper_1sqfv_1", e = "_textArea_1sqfv_9", t = "_error_1sqfv_30", p = "_counterWrapper_1sqfv_62", o = {
  wrapper: r,
  textArea: e,
  error: t,
  counterWrapper: p
};
export {
  p as counterWrapper,
  o as default,
  t as error,
  e as textArea,
  r as wrapper
};
